import { createUseStyles, Styles } from '../../web-styles'

interface DropdownStyles {
  disabledState: Styles
  container: Styles
  selectButton: Styles
  input: Styles
  selectDropdownModal: Styles
  selectDropdownModalOpen: Styles
  arrowIcon: Styles
  arrowIconUp: Styles
}

interface DropdownStylesProps {
  isError: boolean
  isOptionSelected: boolean
}

const DROPDOWN_MODAL_MAX_HEIGHT = 160
const DROPDOWN_BUTTON_MIN_WIDTH = 90
const DROPDOWN_BUTTON_MIN_HEIGHT = 40

export const useStyles = createUseStyles<DropdownStyles, DropdownStylesProps>((theme) => {
  return {
    disabledState: {
      opacity: theme.opacity.semiTransparent,
    },
    container: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'start',
      gap: theme.calcUnit(theme.spacing.s2),
      minWidth: theme.calcUnit(DROPDOWN_BUTTON_MIN_WIDTH),
      width: '100%',
    },
    selectButton: (props) => ({
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      gap: theme.calcUnit(theme.spacing.s2),
      alignContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      justifyContent: 'space-between',
      borderColor: props.isError ? theme.colors.inputErrorBorderColor : theme.colors.inputBorderColor,
      borderWidth: theme.calcUnit(1),
      borderStyle: 'solid',
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      backgroundColor: 'transparent',
      minHeight: theme.calcUnit(DROPDOWN_BUTTON_MIN_HEIGHT),
      padding: `${theme.calcUnit(theme.spacing.s2)} ${theme.calcUnit(theme.spacing.s3)}`,
      // only apply focus style on keyboard navigation and not mouse click
      '&:focus:not(.focus-visible)': {
        outline: 'none',
      },
      '&:focus-within': {
        borderColor: props.isError ? theme.colors.inputErrorBorderColor : theme.colors.inputActiveBorderColor,
        '&:hover': {
          borderColor: props.isError ? theme.colors.inputErrorBorderColor : theme.colors.inputActiveBorderColor,
        },
      },
      '&:hover': {
        outline: 'none',
        borderColor: props.isError ? theme.colors.inputErrorBorderColor : theme.colors.inputHoverBorderColor,
      },
    }),
    input: (props) => ({
      color: props.isOptionSelected ? theme.colors.webTextColor : theme.colors.webTextField,
      borderColor: theme.colors.inputActiveBorderColor,
      textAlign: 'left',
      width: '100%',
      outline: 'none',
      cursor: 'pointer',
      padding: theme.calcUnit(0),
      textOverflow: 'ellipsis',
    }),
    selectDropdownModal: {
      width: '100%',
      borderWidth: theme.calcUnit(1),
      borderStyle: 'solid',
      borderColor: theme.colors.textFieldBorderColor,
      borderRadius: theme.borderRadius.roundedDefault,
      backgroundColor: theme.colors.webBrightBackground,
      listStyle: 'none',
      padding: theme.calcUnit(theme.spacing.s2),
      boxShadow: `${theme.calcUnit(0)} ${theme.calcUnit(1)} ${theme.calcUnit(4)} ${theme.calcUnit(0)} rgba(0, 0, 0, 0.2)`,
      maxHeight: theme.calcUnit(DROPDOWN_MODAL_MAX_HEIGHT),
      overflowY: 'auto',
      scrollbarColor: `${theme.colors.textFieldBorderColor} transparent`,
      zIndex: theme.zIndex.levelOne,
      display: 'none',
      margin: theme.calcUnit(0),
      scrollbarWidth: 'thin',
      scrollBehavior: 'smooth',
    },
    selectDropdownModalOpen: {
      display: 'flex',
      flexDirection: 'column',
    },
    arrowIcon: {
      transform: 'rotateX(0deg)',
      transition: 'transform ease-out 0.3s',
    },
    arrowIconUp: {
      transform: 'rotateX(180deg)',
      transition: 'transform ease-out 0.3s',
    },
  }
})
